import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import * as $ from 'jquery';
import { FormGroup } from "@angular/forms";
import { SearchModel } from '../../models/search-model';
import { FormControl } from '@angular/forms';
import { SubSink } from 'subsink2';
import { TimezoneUtils } from '../../models/timezone-utils';
@Component({
  selector: 'app-advanced-search-client-side',
  templateUrl: './advanced-search-client-side.component.html',
  styleUrls: ['./advanced-search-client-side.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvancedSearchClientSideComponent implements OnInit {

  @Input() advSearchModel: SearchModel;
  @Input() id: string;
  @Input() enableTimezone?: boolean = false;
  @Input() selectedTz?: string;

  @Output() search = new EventEmitter<string>();
  @Output() advancedSearch = new EventEmitter<any>();

  isAdvanced: boolean;
  inputArray: any[];
  advForm: FormGroup;
  optionArray = {};
  filter = '';
  basicSearchQuery = '';

  // for birth month
  protected subs = new SubSink();

  constructor() {
    this.isAdvanced = false;
  }

  ngOnInit() {
    this.advForm = this.advSearchModel?.form;
    this.inputArray = Object.entries(this.advSearchModel.dataType).map((e: any) => e.flatMap(f => f));
    this.extractOptions();
    $(document).mouseup(ev => {
      const container = $(`#${this.id}`);
      const calendar = $('mat-calendar');
      const matOption = $('mat-option');
      const backdrop = $('.cdk-overlay-backdrop');
      if (!matOption.is(ev.target) && !calendar.is(ev.target) && !container.is(ev.target) && !backdrop.is(ev.target)
        && matOption.has(ev.target).length === 0
        && container.has(ev.target).length === 0
        && calendar.has(ev.target).length === 0
        && backdrop.has(ev.target).length === 0) {
        container.hide('fast', 'swing', c => {
          this.isAdvanced = false;
          // this.advForm.reset();
        });
      }
    });
  }

  extractOptions = (fieldName?, fieldValue?) => this.inputArray
    .filter(x => x[1] === 'select')
    .filter(x => fieldName ? x[0] === fieldName : true)
    .forEach(x => {
      const options = x[2]
        .flatMap(e => e)
        .filter(e => fieldValue ? e.toLowerCase().includes(fieldValue.toLowerCase()) : true);
      this.optionArray[x[0]] = options;
    })

  searchToggle() {
    const container = $(`#${this.id}`);
    if (!this.isAdvanced) {
      this.isAdvanced = true;
      container.show('fast', 'swing', c => this.isAdvanced = true);
    }
  }

  optionSearchFilter(query) {
    const fieldName = query.target.parentNode.parentNode.id;
    this.extractOptions(fieldName, query.target.value);
  }

  onAdvancedSearch() {
    // console.log(this.advForm.value);
    const container = $(`#${this.id}`);
    container.hide('fast', 'swing', c => {
      this.isAdvanced = false;
      // this.advForm.reset();
    });
    // this.numberOfFilters = count;
    this.advancedSearch.emit(this.advForm.value);
  }

  reset() {
    this.advForm.reset();
  }

  onBasicSearch(e: string) {
    this.search.emit(e);
  }

  dateChange(newDate: moment.Moment, control: FormControl, selectedTz?: string) {
    if (this.enableTimezone && this.selectedTz) TimezoneUtils.formControlDateChange(newDate, control, selectedTz);
  }
}
